export default {"src":"/_next/static/media/black-furniture.6d56a670.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};